import { useI18n } from 'vue-i18n-composable';
import newsletter from 'grapesjs-preset-newsletter-v2';
import grapesTouch from 'grapesjs-touch';
import grapesImgEditor from 'grapesjs-tui-image-editor';
import grapesjs from 'grapesjs/dist/grapes.min.js';
import useMailTemplateEditor from '@/compositions/useMailTemplateEditor';
import juice from 'juice';
import 'grapesjs/dist/css/grapes.min.css';
import {
  ref, onMounted, watch, computed, toRefs,
} from '@vue/composition-api';
import { localeType } from '@/enums';

export default {
  setup(props, { emit, root }) {
    const { isShowCodeEditor, company, account } = toRefs(props);
    const { t, locale } = useI18n();

    const showDialogResetCode = ref(false);
    const showDialogResetTemplate = ref(false);
    const showDialogTariffPlan = ref(false);

    const frontendUrl = process.env.VUE_APP_FRONT_URL;

    const codeBackup = ref(null);
    const editor = ref(null);
    const isExpert = ref(false);
    const isInitialized = ref(false);

    const companyCountry = computed(() => {
      return company.value?.country;
    });

    const {
      mailTemplate,
      isPublished,
      updateMailTemplate: updateTemplateData,
      applyRedactingMailTemplate: applyRedactingData,
      publishMailTemplate: publishTemplateData,
      unpublishMailTemplate: unpublishTemplateData,
    } = useMailTemplateEditor();

    const ruTemplateWrapperEnd = `
                <tr>
                  <td
                    style="
                      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI',
                        Roboto, Helvetica, Arial, sans-serif,
                        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
                      box-sizing: border-box;
                    "
                  >
                    <table
                      class="footer"
                      align="center"
                      width="570"
                      cellpadding="0"
                      cellspacing="0"
                      role="presentation"
                      style="
                        font-family: -apple-system, BlinkMacSystemFont,
                          'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                          'Apple Color Emoji', 'Segoe UI Emoji',
                          'Segoe UI Symbol';
                        box-sizing: border-box;
                        margin: 0 auto;
                        padding: 0;
                        text-align: left;
                        width: 500px;
                        -premailer-cellpadding: 0;
                        -premailer-cellspacing: 0;
                        -premailer-width: 500px;
                      "
                    >
                      <tbody>
                        <tr>
                          <td
                            class="content-cell-2"
                            align="center"
                            style="
                              font-family: -apple-system, BlinkMacSystemFont,
                                'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                                'Apple Color Emoji', 'Segoe UI Emoji',
                                'Segoe UI Symbol';
                              box-sizing: border-box;
                              padding: 20px 0;
                            "
                          >
                            <p
                              class="small"
                              style="
                                font-family: -apple-system, BlinkMacSystemFont,
                                  'Segoe UI', Roboto, Helvetica, Arial,
                                  sans-serif, 'Apple Color Emoji',
                                  'Segoe UI Emoji', 'Segoe UI Symbol';
                                box-sizing: border-box;
                                margin-top: 0;
                                font-size: 10px;
                                line-height: 14px;
                                color: #999999;
                                text-align: left !important;
                              "
                            >
                              Это письмо отправлено при помощи платформы
                              <a
                                href="${frontendUrl}"
                                target="_blank"
                                style="
                                  font-family: -apple-system, BlinkMacSystemFont,
                                    'Segoe UI', Roboto, Helvetica, Arial,
                                    sans-serif, 'Apple Color Emoji',
                                    'Segoe UI Emoji', 'Segoe UI Symbol';
                                  box-sizing: border-box;
                                  font-size: 10px;
                                  line-height: 14px;
                                  color: #999999;
                                  text-decoration: underline;
                                "
                                >Huntica</a
                              >. Вы получили это письмо, так как предоставили
                              данные работодателю напрямую или опубликовали своё
                              резюме в Интернете. Переходя по любой ссылке, вы
                              даёте согласие на
                              <a
                                href="${frontendUrl}/agree"
                                target="_blank"
                                style="
                                  font-family: -apple-system, BlinkMacSystemFont,
                                    'Segoe UI', Roboto, Helvetica, Arial,
                                    sans-serif, 'Apple Color Emoji',
                                    'Segoe UI Emoji', 'Segoe UI Symbol';
                                  box-sizing: border-box;
                                  font-size: 10px;
                                  line-height: 14px;
                                  color: #999999;
                                  text-decoration: underline;
                                "
                                >обработку персональных данных</a
                              >, а также соглашаетесь с
                              <a
                                href="${frontendUrl}/confidential"
                                target="_blank"
                                style="
                                  font-family: -apple-system, BlinkMacSystemFont,
                                    'Segoe UI', Roboto, Helvetica, Arial,
                                    sans-serif, 'Apple Color Emoji',
                                    'Segoe UI Emoji', 'Segoe UI Symbol';
                                  box-sizing: border-box;
                                  font-size: 10px;
                                  line-height: 14px;
                                  color: #999999;
                                  text-decoration: underline;
                                "
                                >Политикой конфиденциальности</a
                              >.
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </body>
</html>
  `;

    const enTemplateWrapperEnd = `
                <tr>
                  <td
                    style="
                      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI',
                        Roboto, Helvetica, Arial, sans-serif,
                        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
                      box-sizing: border-box;
                    "
                  >
                    <table
                      class="footer"
                      align="center"
                      width="570"
                      cellpadding="0"
                      cellspacing="0"
                      role="presentation"
                      style="
                        font-family: -apple-system, BlinkMacSystemFont,
                          'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                          'Apple Color Emoji', 'Segoe UI Emoji',
                          'Segoe UI Symbol';
                        box-sizing: border-box;
                        margin: 0 auto;
                        padding: 0;
                        text-align: left;
                        width: 500px;
                        -premailer-cellpadding: 0;
                        -premailer-cellspacing: 0;
                        -premailer-width: 500px;
                      "
                    >
                      <tbody>
                        <tr>
                          <td
                            class="content-cell-2"
                            align="center"
                            style="
                              font-family: -apple-system, BlinkMacSystemFont,
                                'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                                'Apple Color Emoji', 'Segoe UI Emoji',
                                'Segoe UI Symbol';
                              box-sizing: border-box;
                              padding: 20px 0;
                            "
                          >
                            <p
                              class="small"
                              style="
                                font-family: -apple-system, BlinkMacSystemFont,
                                  'Segoe UI', Roboto, Helvetica, Arial,
                                  sans-serif, 'Apple Color Emoji',
                                  'Segoe UI Emoji', 'Segoe UI Symbol';
                                box-sizing: border-box;
                                margin-top: 0;
                                font-size: 10px;
                                line-height: 14px;
                                color: #999999;
                                text-align: left !important;
                              "
                            >
                              This email was sent using the
                              <a
                                href="${frontendUrl}"
                                target="_blank"
                                style="
                                  font-family: -apple-system, BlinkMacSystemFont,
                                    'Segoe UI', Roboto, Helvetica, Arial,
                                    sans-serif, 'Apple Color Emoji',
                                    'Segoe UI Emoji', 'Segoe UI Symbol';
                                  box-sizing: border-box;
                                  font-size: 10px;
                                  line-height: 14px;
                                  color: #999999;
                                  text-decoration: underline;
                                "
                                >Huntica</a
                              > platform. You received this email because you
                              provided your information directly to an employer
                              or published your resume online. By clicking any
                              link, you consent to the
                              <a
                                href="${frontendUrl}/agree"
                                target="_blank"
                                style="
                                  font-family: -apple-system, BlinkMacSystemFont,
                                    'Segoe UI', Roboto, Helvetica, Arial,
                                    sans-serif, 'Apple Color Emoji',
                                    'Segoe UI Emoji', 'Segoe UI Symbol';
                                  box-sizing: border-box;
                                  font-size: 10px;
                                  line-height: 14px;
                                  color: #999999;
                                  text-decoration: underline;
                                "
                                >processing of personal data</a
                              > and agree with the
                              <a
                                href="${frontendUrl}/confidential"
                                target="_blank"
                                style="
                                  font-family: -apple-system, BlinkMacSystemFont,
                                    'Segoe UI', Roboto, Helvetica, Arial,
                                    sans-serif, 'Apple Color Emoji',
                                    'Segoe UI Emoji', 'Segoe UI Symbol';
                                  box-sizing: border-box;
                                  font-size: 10px;
                                  line-height: 14px;
                                  color: #999999;
                                  text-decoration: underline;
                                "
                                >Privacy Policy</a
                              >.
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </body>
</html>
  `;

    const templateWrapperEnd = companyCountry.value.locale === localeType.RU ? ruTemplateWrapperEnd : enTemplateWrapperEnd;

    const translatedBlockedTemplate = `
        ${t('blockedTemplate.hello')}<br>
        ${t('blockedTemplate.text1')}<br>
        ${t('blockedTemplate.text2')}<br>
        ${t('blockedTemplate.text3')}
    `;

    const serverTemplateHtml = `
              <tr>
                  <td
                    class="body"
                    width="100%"
                    cellpadding="0"
                    cellspacing="0"
                    style="
                      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI',
                        Roboto, Helvetica, Arial, sans-serif,
                        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
                      box-sizing: border-box;
                      background-color: #ffffff;
                      border: 1px solid #edeff2;
                      border-radius: 8px;
                      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
                      margin: 0;
                      padding: 0;
                      width: 100%;
                      -premailer-cellpadding: 0;
                      -premailer-cellspacing: 0;
                      -premailer-width: 100%;
                    "
                  >
                    <table
                      class="inner-body"
                      align="center"
                      width="500"
                      cellpadding="0"
                      cellspacing="0"
                      role="presentation"
                      style="
                        font-family: -apple-system, BlinkMacSystemFont,
                          'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                          'Apple Color Emoji', 'Segoe UI Emoji',
                          'Segoe UI Symbol';
                        box-sizing: border-box;
                        margin: 0 auto;
                        padding: 0;
                        width: 500px;
                        -premailer-cellpadding: 0;
                        -premailer-cellspacing: 0;
                        -premailer-width: 500px;
                      "
                    >
                      <tbody>
                        <tr>
                          <td
                            class="content-cell-1"
                            style="
                              font-family: -apple-system, BlinkMacSystemFont,
                                'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                                'Apple Color Emoji', 'Segoe UI Emoji',
                                'Segoe UI Symbol';
                              box-sizing: border-box;
                              padding: 35px;
                            "
                          >
                            <!-- Body content -->
                            <div data-mail-body="true">
                              ${translatedBlockedTemplate}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
  `;

    const templateWrapperStart = `
    <html>
  <head>
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  </head>
  <body
    style="
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
        Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
        'Segoe UI Symbol';
      box-sizing: border-box;
      background-color: #f8f8f8;
      color: #74787e;
      height: 100%;
      hyphens: auto;
      line-height: 1.4;
      margin: 0;
      -moz-hyphens: auto;
      -ms-word-break: break-all;
      width: 100% !important;
      -webkit-hyphens: auto;
      -webkit-text-size-adjust: none;
      word-break: break-word;
    "
  >
    <style>
      @media only screen and (max-width: 600px) {
        .inner-body {
          width: 100% !important;
        }

        .footer {
          width: 100% !important;
        }
      }

      @media only screen and (max-width: 500px) {
        .button {
          width: 100% !important;
        }
      }
    </style>

    <table
      class="wrapper"
      width="100%"
      cellpadding="0"
      cellspacing="0"
      role="presentation"
      style="
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
          Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
          'Segoe UI Symbol';
        box-sizing: border-box;
        background-color: #f8fafc;
        margin: 0;
        padding: 0;
        width: 100%;
        -premailer-cellpadding: 0;
        -premailer-cellspacing: 0;
        -premailer-width: 100%;
      "
    >
      <tbody>
        <tr>
          <td
            align="center"
            style="
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
                Helvetica, Arial, sans-serif, 'Apple Color Emoji',
                'Segoe UI Emoji', 'Segoe UI Symbol';
              box-sizing: border-box;
            "
          >
            <table
              class="content"
              width="500"
              cellpadding="0"
              cellspacing="0"
              role="presentation"
              style="
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI',
                  Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
                  'Segoe UI Emoji', 'Segoe UI Symbol';
                box-sizing: border-box;
                margin: 0 auto;
                padding: 0;
                width: 500px;
                -premailer-cellpadding: 0;
                -premailer-cellspacing: 0;
                -premailer-width: 100%;
              "
            >
              <tbody>
                <tr>
                  <td
                    class="header"
                    style="
                      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI',
                        Roboto, Helvetica, Arial, sans-serif,
                        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
                      box-sizing: border-box;
                      padding: 25px 0;
                      text-align: center;
                    "
                  >
                    <a
                      href="${frontendUrl}"
                      style="
                        font-family: -apple-system, BlinkMacSystemFont,
                          'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                          'Apple Color Emoji', 'Segoe UI Emoji',
                          'Segoe UI Symbol';
                        box-sizing: border-box;
                        color: #bbbfc3;
                        font-size: 19px;
                        font-weight: bold;
                        text-decoration: none;
                        text-shadow: 0 1px 0 white;
                      "
                      target="_blank"
                    >
                      <img
                        class="logo"
                        src="data:image/png;base64,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"
                        alt="Huntica"
                        style="
                          font-family: -apple-system, BlinkMacSystemFont,
                            'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
                            'Apple Color Emoji', 'Segoe UI Emoji',
                            'Segoe UI Symbol';
                          box-sizing: border-box;
                          max-width: 100%;
                          margin: 0 auto;
                          border: none;
                          width: 117px;
                        "
                      />
                    </a>
                  </td>
                </tr>
  `;

    const openDialogResetCode = () => {
      showDialogResetCode.value = true;
    };

    const closeDialogResetCode = () => {
      showDialogResetCode.value = false;
    };

    const openDialogResetTemplate = () => {
      showDialogResetTemplate.value = true;
    };

    const closeDialogResetTemplate = () => {
      showDialogResetTemplate.value = false;
    };

    const openDialogTariffPlan = () => {
      showDialogTariffPlan.value = true;
    };

    const cancelDialogTariffPlan = () => {
      showDialogTariffPlan.value = false;
    };

    const toggleMode = () => {
      isExpert.value = !isExpert.value;
      const container = document.querySelector('.editor-page');
      if (container) {
        if (!isExpert.value) {
          container.classList.add('simple-mode');
        } else {
          container.classList.remove('simple-mode');
        }
      }
    };

    const enableSimpleMode = () => {
      if (!editor.value) return;

      ['.gjs-pn-views', '.gjs-pn-views-container'].forEach((selector) => {
        const el = document.querySelector(selector);
        if (el) el.style.display = 'none';
      });

      editor.value.getWrapper().components().forEach((comp) => {
        comp.set({
          removable: false,
          draggable: false,
          droppable: false,
          selectable: true,
          highlightable: true,
          copyable: false,
        });
      });
    };

    const disableSimpleMode = () => {
      ['.gjs-pn-views', '.gjs-pn-views-container'].forEach((selector) => {
        const el = document.querySelector(selector);
        if (el) el.style.display = '';
      });

      editor.value.getWrapper().components().forEach((comp) => {
        comp.set({
          removable: true,
          draggable: true,
          droppable: true,
          selectable: true,
          highlightable: true,
          copyable: true,
          toolbar: null,
        });
      });
    };

    const formatHtml = (html) => {
      const indentChar = '  ';
      let result = '';
      let indent = 0;

      html.replace(/>\s*</g, '><').split(/(?=<)/).forEach((node) => {
        node = node.trim();
        if (!node) return;

        if (/^<\/\w/.test(node)) {
          indent = Math.max(indent - 1, 0);
        }

        node = node.replace(/<(\w+)([^>]*)>/g, (match, tag, attrs) => {
          if (!attrs.trim()) return `<${tag}>`;

          const formattedAttrs = attrs
            .trim()
            .replace(/\s+(\w+=)/g, `\n${indentChar.repeat(indent + 1)}$1`);

          return `<${tag}\n${indentChar.repeat(indent + 1)}${formattedAttrs}>`;
        });

        result += `${indentChar.repeat(indent) + node}\n`;

        if (/^<\w[^>]*[^/]?>$/.test(node) && !/^<input|<img|<br|<hr/.test(node)) {
          indent++;
        }
      });

      return result.trim();
    };

    const changeLocale = () => {
      if (locale.value === 'en') return;

      editor.value.BlockManager.getAll().forEach((block) => {
        const label = block.get('label');

        switch (label) {
          case '1 Section':
            block.set('label', '1 секция');
            break;
          case '2 Columns':
          case '1/2 Section':
            block.set('label', '1/2 секция');
            break;
          case '3/7 Section':
            block.set('label', '3/7 секция');
            break;
          case '3 Columns':
          case '1/3 Section':
            block.set('label', '1/3 секция');
            break;
          case 'Text':
            block.set('label', 'Текст');
            break;
          case 'Text section':
          case 'Text Section':
            block.set('label', 'Текстовая секция');
            break;
          case 'Image':
            block.set('label', 'Изображение');
            break;
          case 'Quote':
            block.set('label', 'Цитата');
            break;
          case 'Button':
            block.set('label', 'Кнопка');
            break;
          case 'Divider':
            block.set('label', 'Разделитель');
            break;
          case 'Link':
            block.set('label', 'ССылка');
            break;
          case 'Link Block':
            block.set('label', 'Секция ссылки');
            break;
          case 'Grid Items':
            block.set('label', 'Элементы сетки');
            break;
          case 'List Items':
            block.set('label', 'Элементы списка');
            break;
          default:
            break;
        }
      });
    };

    const escapeHtml = (str) => {
      return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    };

    const highlightProtectedBlock = (html) => {
      const escaped = escapeHtml(html);

      return escaped.replace(
        /(&lt;div[^&]*data-mail-body="true"[^&]*&gt;[\s\S]*?&lt;\/div&gt;)/,
        '<textarea disabled style="background: #ffcccc; display:inline-block; width:100%; height:444px">$1</textarea>',
      );
    };

    const confirmSaveCode = () => {
      const codeArea = document.getElementById('gjs-import-code');
      if (codeArea && codeBackup.value) {
        codeArea.innerHTML = codeBackup.value.highlighted;
      }
      closeDialogResetCode();
    };

    const openCodeEditor = () => {
      if (editor.value) {
        editor.value.runCommand('gjs-open-import');
        emit('closeCodeEditor');
      }
    };

    const initEditor = () => {
      if (editor.value) {
        editor.value.destroy();
        editor.value = null;
      }

      editor.value = grapesjs.init({
        container: '#gjs',
        height: '456px',
        storageManager: false,
        fromElement: false,
        forceClass: false,
        plugins: [newsletter, grapesTouch, grapesImgEditor],
        pluginsOpts: {},
        avoidInlineStyle: false,
        styleManager: {
          forceInline: true,
        },
        selectorManager: {
          componentFirst: true,
          avoidDefaults: true,
        },
        cssComposer: {
          clearProperties: true,
        },
      });

      changeLocale();

      editor.value.on('load', () => {
        let htmlToLoad = mailTemplate.value.redacting ? mailTemplate.value.redacting : `${templateWrapperStart}${serverTemplateHtml}${templateWrapperEnd}`;

        if (mailTemplate.value.redacting) {
          htmlToLoad = htmlToLoad.replace(
            /{{{MAIL_BODY}}}/g,
            translatedBlockedTemplate,
          );
        }

        editor.value.setComponents(
          htmlToLoad,
        );

        isInitialized.value = true;

        if (!isExpert.value) {
          enableSimpleMode();
          const container = document.getElementById('gjs');
          if (container) container.classList.add('simple-mode');
        } else {
          const container = document.getElementById('gjs');
          if (container) container.classList.remove('simple-mode');
        }

        editor.value.Panels.removeButton('options', 'gjs-open-import-template');
        editor.value.Panels.removeButton('options', 'export-template');
        editor.value.Panels.removeButton('options', 'gjs-toggle-images');

        const bm = editor.value.BlockManager;
        ['button', 'link', 'link-block'].forEach((id) => {
          if (bm.get(id)) bm.remove(id);
        });

        bm.getAll().forEach((block) => {
          const label = block.get('label');
          if (['Button', 'Link', 'Link Block'].includes(label)) {
            bm.remove(block.get('id'));
          }
        });

        setTimeout(() => {
          const panel = editor.value.Panels.getPanel('options');
          if (!panel) return;

          const buttons = panel.get('buttons');
          const panelEl = document.querySelector('.gjs-pn-options');
          if (!panelEl) return;

          const spans = panelEl.querySelectorAll('button, span');

          buttons.each((button) => {
            const id = button.get('id');
            const index = buttons.indexOf(button);
            const domButton = spans[index];
            if (domButton) {
              const titlesMap = {
                'sw-visibility': t('viewComponents'),
                preview: t('preview'),
                fullscreen: t('fullscreen'),
              };
              if (titlesMap[id]) {
                domButton.setAttribute('title', titlesMap[id]);
              }
            }
          });
        }, 300);

        setTimeout(() => {
          const panel = editor.value.Panels.getPanel('views');
          if (!panel) return;

          const buttons = panel.get('buttons');
          const panelEl = document.querySelector('.gjs-pn-views');
          if (!panelEl) return;

          const domButtons = panelEl.querySelectorAll('button, span');

          buttons.each((button) => {
            const id = button.get('id');
            const index = buttons.indexOf(button);
            const domButton = domButtons[index];
            if (domButton && locale.value === localeType.RU) {
              const titlesMap = {
                'open-sm': 'Менеджер стилей',
                'sw-style': 'Менеджер стилей',
                'open-tm': 'Менеджер свойств',
                'sw-trait': 'Менеджер свойств',
                'open-layers': 'Слои',
                'sw-layers': 'Слои',
                'open-blocks': 'Блоки',
                'sw-blocks': 'Блоки',
              };
              if (titlesMap[id]) {
                domButton.setAttribute('title', titlesMap[id]);
              }
            }
          });
        }, 300);

        editor.value.UndoManager.clear();
        editor.value.store();

        const lockTextRecursive = (component) => {
          component.set({
            editable: false,
            removable: false,
            draggable: false,
            droppable: false,
            copyable: false,
            selectable: true,
            stylable: true,
          });

          component.components().forEach((child) => lockTextRecursive(child));
        };

        const lockedWrapper = editor.value.getWrapper().find('.inner-body')[0];
        if (lockedWrapper) {
          lockedWrapper.components().forEach((child) => lockTextRecursive(child));
          lockedWrapper.addAttributes({ 'data-locked': 'true' });
        }

        if (!isExpert.value) {
          enableSimpleMode();
        }
      });

      editor.value.Commands.add('core:undo', {
        run(editor) {
          const canvas = document.querySelector('#gjs');
          if (canvas) canvas.click();

          setTimeout(() => {
            editor.UndoManager.undo();
          }, 50);
        },
      });

      editor.value.Panels.addButton('options', {
        id: 'undo-action',
        className: 'fa fa-undo',
        command: 'core:undo',
        attributes: { title: t('undo') },
      });

      editor.value.Panels.addButton('options', {
        id: 'gjs-open-import',
        className: 'fa fa-edit',
        command: 'gjs-open-import',
        attributes: { title: t('editCode') },
      });

      editor.value.Panels.addButton('options', {
        id: 'toggle-simple-expert',
        className: 'fa fa-graduation-cap',
        command: 'toggle-simple-expert',
        attributes: { title: t('changeMode') },
      });

      editor.value.Commands.add('toggle-simple-expert', {
        run() {
          toggleMode();
        },
      });

      editor.value.Commands.add('gjs-open-import', {
        run(ed) {
          const css = ed.getCss().trim();
          const html = ed.getHtml();

          ed.Modal.open({
            title: t('editingCode'),
            content: `
        <div style="max-height: 755px; overflow: hidden;">
          <div style="display:flex; align-items:center; gap:8px; margin-bottom:10px; background:#e8f4ff; padding:8px 10px; border-radius:6px; border:1px solid #b3daff; font-size:14px; color:#004085;">
            <span style="display:inline-block; width:20px; height:18px; border-radius:50%; background:#007bff; color:#fff; text-align:center; line-height:18px; font-weight:bold; font-size:12px;">i</span>
            <span>${t('editor.codeWarning')}</span>
          </div>
          <div id="gjs-import-area" contenteditable="true" 
               style="width:100%; outline:none; min-width:600px; height:640px; font-family:monospace; white-space:pre-wrap; background:#f8f8f8; color:#333; padding:10px; border:1px solid #ccc; overflow:auto; resize:vertical;">
            <pre id="gjs-import-code" style="margin:0;"></pre>
          </div>
          <button id="gjs-import-btn" 
                  style="margin-top:10px; background:#4CAF50; color:white; padding:5px 10px; border:none; cursor:pointer; border-radius:4px;">
            ${t('save')}
          </button>
        </div>
      `,
          });

          setTimeout(() => {
            const codeArea = document.getElementById('gjs-import-code');
            let safeHtml = juice.inlineContent(html, css);
            safeHtml = safeHtml
              .replace(/<meta[\s\S]*?>/gi, '')
              .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
              .replace(/<link[\s\S]*?>/gi, '');

            const formatted = formatHtml(safeHtml);
            const highlighted = highlightProtectedBlock(formatted);

            codeArea.innerHTML = highlighted;

            codeBackup.value = {
              plain: formatted,
              highlighted,
            };

            const preventEditingLockedBlock = (e) => {
              const selection = window.getSelection();
              if (!selection || selection.rangeCount === 0) return;

              const range = selection.getRangeAt(0);
              const container = document.getElementById('gjs-import-area');
              if (!container) return;

              const fullText = container.textContent || container.innerText || '';
              
              const lockedStart = '<div data-mail-body="true"';
              const lockedStartIndex = fullText.indexOf(lockedStart);
              
              if (lockedStartIndex === -1) {
                return;
              }

              let depth = 0;
              let lockedEndIndex = -1;
              let searchStart = lockedStartIndex;
              
              while (searchStart < fullText.length) {
                const nextDivStart = fullText.indexOf('<div', searchStart + 1);
                const nextDivEnd = fullText.indexOf('</div>', searchStart);
                
                if (nextDivEnd === -1) break;
                
                if (nextDivStart !== -1 && nextDivStart < nextDivEnd) {
                  depth++;
                  searchStart = nextDivStart + 1;
                } else {
                  if (depth === 0) {
                    lockedEndIndex = nextDivEnd + '</div>'.length;
                    break;
                  }
                  depth--;
                  searchStart = nextDivEnd + '</div>'.length;
                }
              }

              if (lockedEndIndex === -1) {
                return;
              }

              const tempRangeStart = document.createRange();
              tempRangeStart.setStart(container, 0);
              tempRangeStart.setEnd(range.startContainer, range.startOffset);
              const selectionStart = tempRangeStart.toString().length;

              const tempRangeEnd = document.createRange();
              tempRangeEnd.setStart(container, 0);
              tempRangeEnd.setEnd(range.endContainer, range.endOffset);
              const selectionEnd = tempRangeEnd.toString().length;

              const isSelectionOverlapping = (
                (selectionStart >= lockedStartIndex && selectionStart < lockedEndIndex) ||
                (selectionEnd > lockedStartIndex && selectionEnd <= lockedEndIndex) ||
                (selectionStart <= lockedStartIndex && selectionEnd >= lockedEndIndex)
              );

              if (isSelectionOverlapping) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            };

            const codeAreaContainer = document.getElementById('gjs-import-area');
            if (codeAreaContainer) {
              codeAreaContainer.addEventListener('keydown', preventEditingLockedBlock);
              codeAreaContainer.addEventListener('paste', preventEditingLockedBlock);
              codeAreaContainer.addEventListener('input', preventEditingLockedBlock);
            }
          }, 0);

          document.getElementById('gjs-import-btn').onclick = () => {
            const container = document.getElementById('gjs-import-area');
            const codeArea = document.getElementById('gjs-import-code');
            
            let newHtml = container.textContent || container.innerText || '';
            
            if (!newHtml || newHtml.trim() === '') {
              newHtml = codeArea.textContent || codeArea.innerText || '';
            }

            const mailBodyPatterns = [
              /data-mail-body\s*=\s*["']?true["']?/i,
              /data-mail-body\s*=\s*true/i,
              /&lt;div[^&]*data-mail-body/i,
              /<div[^>]*data-mail-body/i,
            ];
            
            const hasMailBodyBlock = mailBodyPatterns.some(pattern => pattern.test(newHtml));

            if (!hasMailBodyBlock) {
              const hasMailBodyKeywords = newHtml.toLowerCase().includes('data-mail-body');
              
              if (!hasMailBodyKeywords) {
                openDialogResetCode();
                return;
              }
            }

            const preRegex = new RegExp(
              '<div[^>]*data-mail-body\\s*=\\s*["\']?true["\']?[^>]*>[\\s\\S]*?<\\/div>',
              'i',
            );
            
            const originalLockedBlock = html.match(preRegex)?.[0] || '';
            
            if (!originalLockedBlock) {
              const foundBlock = newHtml.match(preRegex)?.[0];
            } else {
              newHtml = newHtml.replace(preRegex, originalLockedBlock);
            }

            ed.setComponents(newHtml);

            if (css && css.trim() !== '') {
              ed.setStyle(css);
            }

            ed.Modal.close();
          };
        },
      });

      editor.value.on('run:open-assets', () => {
        const assetsEl = document.querySelector('.gjs-am-assets');
        if (!assetsEl) return;

        const handleClick = (e) => {
          const assetEl = e.target.closest('.gjs-am-asset');
          if (assetEl) {
            setTimeout(() => {
              editor.value.Modal.close();
            }, 100);
          }
        };

        assetsEl.addEventListener('click', handleClick, { once: true });
      });
    };

    const updateTemplate = async () => {
      if (!isInitialized.value) return;

      editor.value.setStyle('');

      let cleanHtml = editor.value.getHtml();
      cleanHtml = cleanHtml.replace(
        /(<div[^>]*data-mail-body="true"[^>]*>)[\s\S]*?(<\/div>)/,
        '$1{{{MAIL_BODY}}}$2',
      );

      const css = editor.value.getCss();
      const globalCss = `
        .btn, .button {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
          box-sizing: border-box;
          font-size: 14px;
          border-radius: 3px;
          box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
          color: #fff;
          display: inline-block;
          text-decoration: none;
          -webkit-text-size-adjust: none;
          background-color: #0A82D9;
          border-top: 10px solid #0A82D9;
          border-right: 18px solid #0A82D9;
          border-bottom: 10px solid #0A82D9;
          border-left: 18px solid #0A82D9;
          cursor: pointer;
          white-space: nowrap;
        }
        a {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
          box-sizing: border-box;
          color: #0A82D9;
          font-size: 14px;
        }
        span p {
          color: inherit !important;
        }
        .btn a {
          color: #fff !important;
        }
        img {
          max-width: 100%;
          height: auto;
          display: block;
        }
      `;

      const fullHtml = `
      <html>
        <head>
          <meta charset="UTF-8">
          <style>${globalCss}${css}</style>
        </head>
        <body>
          ${cleanHtml}
        </body>
      </html>`;

      const inlinedHtml = juice.inlineContent(fullHtml, globalCss + css);
      await updateTemplateData({ template: inlinedHtml });
    };

    const applyRedacting = async () => {
      await updateTemplate();
      await applyRedactingData();
    };

    const publishTemplate = async () => {
      if (!account.value.mailTemplate) {
        openDialogTariffPlan();
        return;
      }
      await applyRedacting();
      await publishTemplateData();
      root.$toast.success(t('published'));
    };

    const unpublishTemplate = async () => {
      await unpublishTemplateData();
    };

    const resetEditor = async () => {
      if (!editor.value) return;

      const initialHtml = `${templateWrapperStart}${serverTemplateHtml}${templateWrapperEnd}`;

      editor.value.setComponents(initialHtml);
      editor.value.setStyle('');

      await applyRedacting();

      if (isPublished.value) {
        await unpublishTemplate();
      }

      closeDialogResetTemplate();
      root.$toast.success(t('templateReset'));
    };

    onMounted(async () => {
      initEditor();
    });

    watch(isExpert, (val) => {
      if (!editor.value) return;
      if (val) {
        disableSimpleMode();
        document.getElementById('gjs').classList.remove('simple-mode');
      } else {
        enableSimpleMode();
        document.getElementById('gjs').classList.add('simple-mode');
      }
    });

    watch(
      () => isShowCodeEditor.value,
      (newVal) => {
        if (newVal && editor.value) {
          openCodeEditor();
        }
      },
    );

    return {
      editor,
      isExpert,
      toggleMode,
      updateTemplate,
      publishTemplate,
      applyRedacting,
      unpublishTemplate,
      confirmSaveCode,
      isPublished,
      showDialogResetCode,
      openDialogResetCode,
      closeDialogResetCode,
      resetEditor,
      showDialogResetTemplate,
      openDialogResetTemplate,
      closeDialogResetTemplate,
      showDialogTariffPlan,
      cancelDialogTariffPlan,
    };
  },
};
